import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { StudentApiServiceService } from '../pages/personnel/student/student-api-service.service';

@Injectable({
  providedIn: 'root'
})
export class StudentCachedService {
  private students$?: Observable<any>;

  constructor(private studentApi: StudentApiServiceService) {}

  /**
   * Loads student list once per app lifetime (per browser session) and caches it.
   */
  getStudentsOnce(page?: number, params?: any): Observable<any> {
    if (!this.students$) {
      this.students$ = this.studentApi.getStudentList(page, params).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.students$;
  }

  /** Optional: allow manual refresh when needed. */
  refreshStudentsOnce(page?: number, params?: any): void {
    this.students$ = undefined;
    // Next getStudentsOnce() call will re-fetch.
  }
}

